export enum MeetingTypeEnum {
    COUNTER = "COUNTER",
    RENTAL_SHUTTLE = "RENTAL_SHUTTLE",
    CALL = "CALL",
    AIRPORT_SHUTTLE = "AIRPORT_SHUTTLE"
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/meeting-type.enum.ts